// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-nav-shell {
  --left-nav-collapsed-width: clamp(5.2rem, 5.6vw, 6.4rem);
  --left-nav-rail-item-min-height: clamp(3.25rem, 7.2vh, 4.8rem);
  --left-nav-rail-icon-size: clamp(1.85rem, 3.6vh, 2.55rem);
  --left-nav-menu-icon-size: clamp(1.8rem, 3.4vh, 2.45rem);
  --left-nav-tree-icon-size: clamp(1.25rem, 1.4vw, 1.6rem);
  --left-nav-label-size: clamp(0.66rem, 1.0vh, 0.82rem);
  --left-nav-item-gap: clamp(0.08rem, 0.3vh, 0.2rem);
  --left-nav-rail-gap: clamp(0.04rem, 0.3vh, 0.22rem);
  position: relative;
  width: var(--left-nav-collapsed-width);
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e5eaf2;
  background: #ffffff;
  box-shadow: 2px 0 8px rgba(15, 23, 42, 0.04);
  overflow: visible;
}

.side-nav-shell--full-tree {
  width: 17rem;
}

.side-nav-shell__content {
  width: 100%;
  flex: 1 1 auto;
  min-height: 100%;
  transition: width 200ms ease;
  display: flex;
  flex-direction: column;
}

.side-nav-shell__content--expanded {
  width: 17rem;
}

.side-nav-shell__rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--left-nav-rail-gap);
  padding: clamp(0.2rem, 0.55vh, 0.4rem) 0.2rem clamp(0.2rem, 0.55vh, 0.4rem);
  min-height: 0;
  flex: 1 1 auto;
}

.side-nav-shell__rail sb-left-nav-rail-item:first-child {
  --left-nav-current-icon-size: var(--left-nav-menu-icon-size);
}

.side-nav-shell__full-tree {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
}

.side-nav-shell__full-tree-header {
  padding: 0.5rem 0.5rem;
  border-bottom: 1px solid #dbe4f1;
}

.left-nav-expanded-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  border: 0;
  background: transparent;
  border-radius: 0.5rem;
  padding: 0.5rem 0.625rem;
  color: #1f2937;
  cursor: pointer;
  text-align: left;
  transition: background-color 120ms ease, color 120ms ease;
}

.left-nav-expanded-header:hover,
.left-nav-expanded-header:focus-visible {
  background: #e8f0fb;
  color: #0f2f52;
  outline: none;
}

.left-nav-expanded-header__icon {
  width: var(--left-nav-menu-icon-size);
  height: var(--left-nav-menu-icon-size);
  object-fit: contain;
  display: block;
  flex: 0 0 auto;
}

.left-nav-expanded-header__label {
  flex: 1 1 auto;
  font-size: 0.9rem;
  font-weight: 600;
}

.left-nav-expanded-header__chevron {
  margin-left: auto;
  font-size: 1.25rem;
  line-height: 1;
  color: #64748b;
}

.side-nav-shell__full-tree-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.5rem 0.5rem 0.75rem;
  min-height: 0;
  flex: 1 1 auto;
}

.side-nav-version {
  margin-top: auto;
  flex-shrink: 0;
  padding: 0.45rem 0.2rem 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #e5eaf2;
  width: 100%;
  background: #ffffff;
}

.side-nav-version--tree {
  padding: 0.45rem 0.75rem 0.5rem;
  justify-content: flex-start;
}

.side-nav-version__label {
  font-size: 0.65rem;
  font-weight: 500;
  color: #94a3b8;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.side-nav-shell__flyout {
  position: absolute;
  top: 0;
  left: calc(var(--left-nav-collapsed-width) + 0.35rem);
  z-index: 1040;
}

@media (max-height: 760px) {
  .side-nav-shell {
    --left-nav-rail-item-min-height: clamp(3rem, 6.2vh, 4.2rem);
    --left-nav-rail-icon-size: clamp(1.65rem, 3.2vh, 2.2rem);
    --left-nav-menu-icon-size: clamp(1.55rem, 3vh, 2.1rem);
    --left-nav-label-size: clamp(0.62rem, 0.9vh, 0.76rem);
    --left-nav-item-gap: clamp(0.05rem, 0.22vh, 0.16rem);
    --left-nav-rail-gap: clamp(0.03rem, 0.22vh, 0.16rem);
  }
  .side-nav-shell__rail {
    padding-top: 0.15rem;
    padding-bottom: 0.15rem;
  }
  .side-nav-shell__full-tree-header {
    padding: 0.375rem 0.5rem;
  }
  .left-nav-expanded-header {
    padding: 0.4rem 0.55rem;
  }
  .left-nav-expanded-header__label {
    font-size: 0.85rem;
  }
  .side-nav-shell__full-tree-list {
    padding-top: 0.35rem;
    padding-bottom: 0.6rem;
  }
}
@media (max-height: 660px) {
  .side-nav-shell {
    --left-nav-rail-item-min-height: clamp(2.75rem, 5.3vh, 3.75rem);
    --left-nav-rail-icon-size: clamp(1.45rem, 2.8vh, 1.95rem);
    --left-nav-menu-icon-size: clamp(1.4rem, 2.6vh, 1.9rem);
    --left-nav-label-size: clamp(0.58rem, 0.82vh, 0.7rem);
    --left-nav-item-gap: clamp(0.03rem, 0.16vh, 0.12rem);
    --left-nav-rail-gap: clamp(0.02rem, 0.16vh, 0.12rem);
  }
  .side-nav-shell__rail {
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
  }
  .side-nav-shell__full-tree-header {
    padding: 0.3rem 0.45rem;
  }
  .left-nav-expanded-header {
    padding: 0.32rem 0.5rem;
    gap: 0.45rem;
  }
  .left-nav-expanded-header__label {
    font-size: 0.8rem;
  }
  .side-nav-shell__full-tree-list {
    gap: 0.12rem;
    padding: 0.3rem 0.45rem 0.5rem;
  }
}
@media (max-height: 560px) {
  .side-nav-shell {
    overflow-y: auto;
  }
  .side-nav-shell::-webkit-scrollbar {
    width: 0.45rem;
  }
  .side-nav-shell::-webkit-scrollbar-track {
    background: transparent;
  }
  .side-nav-shell::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.55);
    border-radius: 999px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/containers/side-nav/side-nav.component.scss"],"names":[],"mappings":"AAEA;EACI,wDAAA;EACA,8DAAA;EACA,yDAAA;EACA,wDAAA;EACA,wDAAA;EACA,qDAAA;EACA,kDAAA;EACA,mDAAA;EAEA,kBAAA;EACA,sCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,mBAAA;EACA,4CAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,2EAAA;EACA,aAAA;EACA,cAAA;AAFJ;;AAKA;EACI,4DAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,gCAAA;AAFJ;;AAKA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;AAFJ;;AAKA;;EAEI,mBAAA;EACA,cAAA;EACA,aAAA;AAFJ;;AAKA;EACI,qCAAA;EACA,sCAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAFJ;;AAKA;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,cAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,cAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,+BAAA;EACA,2BAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,MAAA;EACA,qDAAA;EACA,aAAA;AAFJ;;AAKA;EACI;IACI,2DAAA;IACA,wDAAA;IACA,sDAAA;IACA,qDAAA;IACA,oDAAA;IACA,oDAAA;EAFN;EAKE;IACI,oBAAA;IACA,uBAAA;EAHN;EAME;IACI,wBAAA;EAJN;EAOE;IACI,uBAAA;EALN;EAQE;IACI,kBAAA;EANN;EASE;IACI,oBAAA;IACA,sBAAA;EAPN;AACF;AAUA;EACI;IACI,+DAAA;IACA,yDAAA;IACA,uDAAA;IACA,qDAAA;IACA,oDAAA;IACA,oDAAA;EARN;EAWE;IACI,mBAAA;IACA,sBAAA;EATN;EAYE;IACI,uBAAA;EAVN;EAaE;IACI,uBAAA;IACA,YAAA;EAXN;EAcE;IACI,iBAAA;EAZN;EAeE;IACI,YAAA;IACA,8BAAA;EAbN;AACF;AAgBA;EACI;IACI,gBAAA;EAdN;EAiBE;IACI,cAAA;EAfN;EAkBE;IACI,uBAAA;EAhBN;EAmBE;IACI,qCAAA;IACA,oBAAA;EAjBN;AACF","sourcesContent":["@import 'styles/core/variables.scss';\n\n.side-nav-shell {\n    --left-nav-collapsed-width: clamp(5.2rem, 5.6vw, 6.4rem);\n    --left-nav-rail-item-min-height: clamp(3.25rem, 7.2vh, 4.8rem);\n    --left-nav-rail-icon-size: clamp(1.85rem, 3.6vh, 2.55rem);\n    --left-nav-menu-icon-size: clamp(1.8rem, 3.4vh, 2.45rem);\n    --left-nav-tree-icon-size: clamp(1.25rem, 1.4vw, 1.6rem);\n    --left-nav-label-size: clamp(0.66rem, 1.0vh, 0.82rem);\n    --left-nav-item-gap: clamp(0.08rem, 0.3vh, 0.2rem);\n    --left-nav-rail-gap: clamp(0.04rem, 0.3vh, 0.22rem);\n\n    position: relative;\n    width: var(--left-nav-collapsed-width);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid #e5eaf2;\n    background: #ffffff;\n    box-shadow: 2px 0 8px rgba(15, 23, 42, 0.04);\n    overflow: visible;\n}\n\n.side-nav-shell--full-tree {\n    width: 17rem;\n}\n\n.side-nav-shell__content {\n    width: 100%;\n    flex: 1 1 auto;\n    min-height: 100%;\n    transition: width 200ms ease;\n    display: flex;\n    flex-direction: column;\n}\n\n.side-nav-shell__content--expanded {\n    width: 17rem;\n}\n\n.side-nav-shell__rail {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: var(--left-nav-rail-gap);\n    padding: clamp(0.2rem, 0.55vh, 0.4rem) 0.2rem clamp(0.2rem, 0.55vh, 0.4rem);\n    min-height: 0;\n    flex: 1 1 auto;\n}\n\n.side-nav-shell__rail sb-left-nav-rail-item:first-child {\n    --left-nav-current-icon-size: var(--left-nav-menu-icon-size);\n}\n\n.side-nav-shell__full-tree {\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    flex: 1 1 auto;\n}\n\n.side-nav-shell__full-tree-header {\n    padding: 0.5rem 0.5rem;\n    border-bottom: 1px solid #dbe4f1;\n}\n\n.left-nav-expanded-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n    border: 0;\n    background: transparent;\n    border-radius: 0.5rem;\n    padding: 0.5rem 0.625rem;\n    color: #1f2937;\n    cursor: pointer;\n    text-align: left;\n    transition: background-color 120ms ease, color 120ms ease;\n}\n\n.left-nav-expanded-header:hover,\n.left-nav-expanded-header:focus-visible {\n    background: #e8f0fb;\n    color: #0f2f52;\n    outline: none;\n}\n\n.left-nav-expanded-header__icon {\n    width: var(--left-nav-menu-icon-size);\n    height: var(--left-nav-menu-icon-size);\n    object-fit: contain;\n    display: block;\n    flex: 0 0 auto;\n}\n\n.left-nav-expanded-header__label {\n    flex: 1 1 auto;\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.left-nav-expanded-header__chevron {\n    margin-left: auto;\n    font-size: 1.25rem;\n    line-height: 1;\n    color: #64748b;\n}\n\n.side-nav-shell__full-tree-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    padding: 0.5rem 0.5rem 0.75rem;\n    min-height: 0;\n    flex: 1 1 auto;\n}\n\n.side-nav-version {\n    margin-top: auto;\n    flex-shrink: 0;\n    padding: 0.45rem 0.2rem 0.5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-top: 1px solid #e5eaf2;\n    width: 100%;\n    background: #ffffff;\n}\n\n.side-nav-version--tree {\n    padding: 0.45rem 0.75rem 0.5rem;\n    justify-content: flex-start;\n}\n\n.side-nav-version__label {\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: #94a3b8;\n    letter-spacing: 0.03em;\n    white-space: nowrap;\n}\n\n.side-nav-shell__flyout {\n    position: absolute;\n    top: 0;\n    left: calc(var(--left-nav-collapsed-width) + 0.35rem);\n    z-index: 1040;\n}\n\n@media (max-height: 760px) {\n    .side-nav-shell {\n        --left-nav-rail-item-min-height: clamp(3rem, 6.2vh, 4.2rem);\n        --left-nav-rail-icon-size: clamp(1.65rem, 3.2vh, 2.2rem);\n        --left-nav-menu-icon-size: clamp(1.55rem, 3vh, 2.1rem);\n        --left-nav-label-size: clamp(0.62rem, 0.9vh, 0.76rem);\n        --left-nav-item-gap: clamp(0.05rem, 0.22vh, 0.16rem);\n        --left-nav-rail-gap: clamp(0.03rem, 0.22vh, 0.16rem);\n    }\n\n    .side-nav-shell__rail {\n        padding-top: 0.15rem;\n        padding-bottom: 0.15rem;\n    }\n\n    .side-nav-shell__full-tree-header {\n        padding: 0.375rem 0.5rem;\n    }\n\n    .left-nav-expanded-header {\n        padding: 0.4rem 0.55rem;\n    }\n\n    .left-nav-expanded-header__label {\n        font-size: 0.85rem;\n    }\n\n    .side-nav-shell__full-tree-list {\n        padding-top: 0.35rem;\n        padding-bottom: 0.6rem;\n    }\n}\n\n@media (max-height: 660px) {\n    .side-nav-shell {\n        --left-nav-rail-item-min-height: clamp(2.75rem, 5.3vh, 3.75rem);\n        --left-nav-rail-icon-size: clamp(1.45rem, 2.8vh, 1.95rem);\n        --left-nav-menu-icon-size: clamp(1.4rem, 2.6vh, 1.9rem);\n        --left-nav-label-size: clamp(0.58rem, 0.82vh, 0.7rem);\n        --left-nav-item-gap: clamp(0.03rem, 0.16vh, 0.12rem);\n        --left-nav-rail-gap: clamp(0.02rem, 0.16vh, 0.12rem);\n    }\n\n    .side-nav-shell__rail {\n        padding-top: 0.1rem;\n        padding-bottom: 0.1rem;\n    }\n\n    .side-nav-shell__full-tree-header {\n        padding: 0.3rem 0.45rem;\n    }\n\n    .left-nav-expanded-header {\n        padding: 0.32rem 0.5rem;\n        gap: 0.45rem;\n    }\n\n    .left-nav-expanded-header__label {\n        font-size: 0.8rem;\n    }\n\n    .side-nav-shell__full-tree-list {\n        gap: 0.12rem;\n        padding: 0.3rem 0.45rem 0.5rem;\n    }\n}\n\n@media (max-height: 560px) {\n    .side-nav-shell {\n        overflow-y: auto;\n    }\n\n    .side-nav-shell::-webkit-scrollbar {\n        width: 0.45rem;\n    }\n\n    .side-nav-shell::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    .side-nav-shell::-webkit-scrollbar-thumb {\n        background: rgba(148, 163, 184, 0.55);\n        border-radius: 999px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
